import React from 'react';
import {StepImplementationProps, StepState} from '../../../../../types/checkoutApp.types';
import {Step} from '../../StepsManager/Components/Step';
import {AdditionalDetailsStepOpen} from './Components/AdditionalDetailsStepOpen';
import {useControllerProps} from '../../../Widget/ControllerContext';

export enum AdditionalDetailsStepDataHook {
  root = 'AdditionalDetailsStep.root',
  collapsed = 'AdditionalDetailsStep.collapsed',
  open = 'AdditionalDetailsStep.open',
  empty = 'AdditionalDetailsStep.empty',
}
// eslint-disable-next-line sonarjs/cognitive-complexity
export const AdditionalDetailsStep = ({index}: StepImplementationProps) => {
  const {
    stepsManagerStore: {stepsList},
    checkoutStore: {cart},
  } = useControllerProps();

  const stepState = stepsList[index!]?.state;
  const getTitle = (): string => {
    if (stepState === StepState.OPEN && cart.forms!.length > 1) {
      return `***Additional Details (${cart.forms!.length})***`;
    }

    return '***Additional Details***';
  };

  const titleText = getTitle();

  return (
    <Step
      index={index!}
      title={titleText}
      dataHook={AdditionalDetailsStepDataHook.root}
      openComponent={AdditionalDetailsStepOpen}
      emptyComponent={() => <div data-hook={AdditionalDetailsStepDataHook.empty}></div>}
      collapsedComponent={() => <div data-hook={AdditionalDetailsStepDataHook.collapsed}></div>}
    />
  );
};
